import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ButtonMinimal } from '@/components/ButtonMinimal';
import { ErrorMessage } from '@/components/ErrorMessage';
import { Spinner } from '@/components/Spinner';
import { type DetailedBagProducts } from '@/modules/bag/aliases';
import { useDeleteFromBag } from '@/modules/bag/useDeleteFromBag';

type Props = {
  products: DetailedBagProducts;
  sellerId: number;
};

function BagDeleteSoldOutItems({ products, sellerId }: Props) {
  const t = useTranslations('bag');
  const { deleteFromBag, errorText, isDeletingOrDeleted } = useDeleteFromBag();

  function handleDeleteClick() {
    deleteFromBag(
      products.map((product) => ({
        product_id: product.id,
        variant_id: product.variant_id || undefined,
        quantity: 0,
        seller_id: sellerId,
      }))
    );
  }

  return isDeletingOrDeleted ? (
    <Spinner className={styles.spinner} />
  ) : (
    <>
      <ButtonMinimal
        className={styles.deleteButton}
        onClick={handleDeleteClick}
      >
        <Body variant="sm-regular" className={styles.deleteText}>
          {t('Bag.SoldOut.Button')}
        </Body>
      </ButtonMinimal>
      {errorText && <ErrorMessage>{errorText}</ErrorMessage>}
    </>
  );
}

export { BagDeleteSoldOutItems };
